import { styled } from '@mui/material/styles';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Typography } from '@mui/material';
import { StyledBannerDiscount, StyledCardFootnote } from '../../../../sharedStyles/textStyles';

export const StyledLocationWrapper = styled('div')(
  ({ theme, isOnlyLocation }) => `
    background: ${theme.DS_palette.primary.white};
    padding: ${theme.DS_spacing(['sm'])};
    display: flex;
    flex-direction: column;
    flex: 0 0 ${isOnlyLocation ? '88%' : '73%'};
    border-radius: 0.75rem;
    box-shadow: 5px 17px 32px 0px rgba(0, 0, 0, 0.07);
    min-height: 175px;

    &:first-of-type {
      margin-left: ${theme.DS_spacing(['md'])};
    }
    &:last-of-type {
      margin-right: ${theme.DS_spacing(['md'])};
    }
    
    &.selected {
      background: ${theme.DS_palette.background.lightBlue};
    }
    
    ${theme.breakpoints.up('md')} {
     flex: 0 0 44%;
      
      &:first-of-type {
        margin-left: 0.75rem;
      }
      &:last-of-type {
        margin-right: 0.75rem;
      }
    }
    ${theme.breakpoints.up('lg')} {
      flex: 0 0 50%;
      box-shadow: none;
      padding: ${theme.DS_spacing(['md'])};
      flex-flow: row nowrap;
      gap: ${theme.DS_spacing(['md'])};
      border-radius: unset;
      border-bottom: unset;
      
      .fix-width button {
        min-width: 216px;
        width: 100%;
      }
           
      &:first-of-type {
        margin-left: 0;
      }
      &:last-of-type {
        margin-right: 0;
     
      }
    }
  `,
);

const noDatesStyles = $noDates =>
  $noDates &&
  `
  justify-content: space-between;
  align-items: center;
`;

export const StyledLocationColumn = styled('div')(
  ({ theme, $noDates }) => `
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-flow: column nowrap;
  ${noDatesStyles($noDates)};
  flex: 1 0 calc(50% - ${theme.DS_spacing(['sm'])});

`,
);

export const StyledLocationImage = styled(GatsbyImage)`
  border-radius: 6px;
  max-height: 160px;
`;

export const StyledLocationHeader = styled('div')(
  ({ theme }) => `
    width: 100%;
    height: 30px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    margin-bottom: ${theme.DS_spacing(['xxs'])};

  `,
);

export const StyledDistancePlaceholder = styled(Typography)(
  ({ theme }) => `
    display: flex;
    justify-content: center;
    align-items: center;
    color: rgb(113, 113, 113);
  
    ${theme.breakpoints.up('lg')} {
      font-size: 0.85rem;
    }
  `,
);

export const StyledWailistLink = styled('div')(
  ({ theme }) => `
    flex: 1;
    display: flex;
    justify-content: center;
    margin-top: ${theme.DS_spacing(['xs'])};
      div {
        margin-bottom: unset;
  
      }
  
   button {
      align-self: flex-end;
      padding: 0;
      min-width: 247px;
  
      &:hover {
      box-shadow: none;
      background-color: transparent;
      }
      > span > span {
       margin-bottom: 0;
  margin-top: ${theme.DS_spacing(['md'])};
      }
      
    
    }
   

    ${theme.breakpoints.up('lg')} {
       button {
        min-width: 254px;
        > span > span{
          margin-bottom: unset
          margin-top: ${theme.DS_spacing(['md'])};
        }
        > span > div {
          margin-left: ${theme.DS_spacing(['xxxs'])};
          svg{
            width: 32px;
            height: 32px;
            path {
               stroke-width: 0.2px;
               stroke:${theme.DS_palette.buttons.enabled};
               fill: ${theme.DS_palette.buttons.enabled};
           }
         
          }
        }
      }
    }
  `,
);

export const StyledNoDates = styled(Typography)(
  ({ theme }) => `
    margin-top: 0;
    padding: 0 ${theme.DS_spacing(['xxs'])} 2px;
    color:  ${theme.DS_palette.text.secondary};
    text-align: center;
    width: 100%;
  `,
);

export const StyledLoaderWrapper = styled('div')(
  () => `
   min-height: 50px;
   display: flex;
   justify-content: center;
   margin-top: 20px;
  `,
);

export const StyledTextWrapper = styled('div')(
  () => `
   min-height: 160px;
  
  `,
);

export const StyledWrapperDiscount = styled('div')(
  ({ theme }) => `
     ${StyledBannerDiscount({ theme })};
     margin-top: ${theme.DS_spacing(['xs'])};
     ${theme.breakpoints.up('lg')} { 
        margin: ${theme.DS_spacing(['xs'])} ${theme.DS_spacing(['md'])} 0;
     }
   `,
);

export const StyledFootnoteCard = styled('div')(
  ({ theme }) => `
    ${StyledCardFootnote({ theme })};
  `,
);
